import { render, staticRenderFns } from "./ContentSolution.vue?vue&type=template&id=20a2c7ba&scoped=true&"
import script from "./ContentSolution.vue?vue&type=script&lang=js&"
export * from "./ContentSolution.vue?vue&type=script&lang=js&"
import style0 from "./ContentSolution.vue?vue&type=style&index=0&id=20a2c7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2c7ba",
  null
  
)

export default component.exports